export function combine(topicList){ 
    let jsonDict = {"topics": topicList};
    return jsonDict;
};